<template>
  <a-layout-header class="header" v-if="$route.name != 'agreement'">
    <nav class="max-container">
      <div class="navbar-left">
        <div>
          <img src="@img/logo.png" alt />
        </div>
      </div>
      <div class="navbar-right">
        <ul class="link-list">
          <li
            v-for="item in linkList"
            :key="item.id"
            :class="{ active: $route.name == item.path ? 'active' : '' }"
            @click="toPage(item.path, item.id)"
          >
            {{ item.name }}
          </li>

          <li class="login" v-if="!isLogin">
            <span @click="trigger(0)">登录</span>/<span @click="trigger(1)">注册</span>
            <img
              src="@img/user_default.png"
              class="head-img"
              alt
              @click="trigger"
            />
          </li>
          <li class="usermsg" v-if="isLogin">
            <a-dropdown placement="bottomCenter" style="margin-right: 10px">
              
              <a
                class="ant-dropdown-link"
                href="#"
                style="color: rgba(0, 0, 0, 0.65)"
              >
              
                {{ userAcount }}
                <img
                  src="@img/user_default.png"
                  class="head-img"
                  alt
                  @click="toPage('user')"
                />
              </a>
              <a-menu slot="overlay" style="text-align: center">
                <a-menu-item
                  v-for="i in collectList"
                  :key="i.id"
                  style="width: 120px; height: 40px"
                  @click="toCollect(i.id)"
                >
                  {{ i.title }}
                </a-menu-item>
                <a-menu-item style="border-top: 1px solid #e2e2e2" @click="log">
                  退出登录
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            
          </li>
        </ul>
      </div>
      <a-alert
        :message="errmsg"
        v-if="errshow"
        class="errshow"
        type="error"
        showIcon
      />
    </nav>
    <div class="shades" v-show="logot"></div>
    <div class="reply" v-show="logot">
      <img src="@img/menu.png" class="quxiao" @click="showfals" />
      <p>确定退出账号吗?</p>
      <a-button class="reply-btn" type="primary" block @click="logOut"
        >确定</a-button
      >
      <a-button class="reply-btn reply-btns" block @click="showfals"
        >取消</a-button
      >
    </div>
    <!-- <div class="sidebar">
      <ul>
        <li @mouseenter="enter(1)" @mouseleave="leave(1)">
          <div class="icon icons">
            <img src="@img/qq.png" alt="" class="imgs" />
            <p>QQ咨询</p>
          </div>
          <div class="contact-pannel" v-show="seen">
            <p class="contact-title">QQ在线咨询</p>
            <a
              target="_blank"
              href="http://wpa.qq.com/msgrd?v=3&uin=1940806221&site=qq&menu=yes"
              class="qq-wrap"
            >
              <img
                class="side-qq"
                src="https://public.ieway.cn/public/v5/imgs/side_qq.png"
                alt=""
              />
              <span>客服一号</span>
            </a>
            <div
              style="
                color: #a3a3a3;
                font-size: 12px;
                padding: 10px 20px;
                line-height: 20px;
                text-align: left;
              "
            >
              客服工作时间：<br />周一至周五9:00-18:30
            </div>
          </div>
        </li>
        <li @mouseenter="enter(2)" @mouseleave="leave(2)">
          <div class="icon iconss">
            <img src="@img/wx.png" alt="" class="imgs" />
            <p>公众号</p>
          </div>
          <div class="contact-pannel" v-show="seen1">
            <img src="@img/fhzj.jpg" alt="" class="erweima" />
            <p class="contact-title">扫一扫，关注凤凰职教 微信公众号</p>
          </div>
        </li>
        <li @mouseenter="enter(3)" @mouseleave="leave(3)">
          <div class="icon iconss">
            <img src="@img/app.png" alt="" class="imgs" />
            <p>抖音</p>
          </div>
          <div class="contact-pannel" v-show="seen2">
            <img src="@img/douyin.jpg" alt="" class="erweima" />
          </div>
        </li>
        <li onClick="window.open('http://xiaowei.ke.qq.com/')">
          <div class="icon iconss">
            <img src="@img/live_board.png" alt="" class="imgs" />
            <p>直播课堂</p>
          </div>
        </li>
        <li @click="smoothscroll">
          <div class="icon iconss">
            <img src="@img/top.png" alt="" class="imgs" />
            <p>返回顶部</p>
          </div>
        </li>
      </ul>
    </div> -->
  </a-layout-header>
</template>
<script>
import { delCookie } from '../../../utils/tool'
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      linkList: [{name:"首页",id:1,path:"index"},{name:"课程",id:2,path:"course"},
        // {name:"报考查询",id:10,path:'application'},
        // {name:"在线题库",id:3,path:"question"},
        {name:"资讯",id:4,path:"info"},
        {name:"名师",id:5,path:"teacher"},
        // {name:"联系我们",id:7,path:"call_us"},
        // {name:"下载中心",id:9,path: "download"}
        ],
      userData: "",
      collectList: [
        { title: "我的课程", id: 0 },
        { title: "我的评论", id: 1 }
        // { title: "我的收藏", id: 2 },
        // { title: "课程学习记录", id: 3 },
        // { title: "关注的老师", id: 4 }
        ],
      errshow: false,
      topCateGoryTitle: '',
      otherCateGoryList: [],
      logot: false,
      seen: false,
      seen1: false,
      seen2: false,
      showItems: "index",
    };
  },
  props: ["userAcount"],
  computed: {
      ...mapState(["isLogin", "h_title", "topCateGoryList"])
    },

  methods: {
    showfalss() {
      this.firstChose = false
    },
    handleChange(item) {
      this.topttile = item.title;
      this.topid = item.id
    },
    logOuts() {
      this.topCateGoryTitle = this.topttile;
      this.firstChose = false
      this.$router.go(0);
    },
    smoothscroll(){
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.smoothscroll);
        window.scrollTo (0,currentScroll - (currentScroll/5));
      }
    },
    enter(e){
      // console.log(e)
      if (e == 1) {
        this.seen = true
      } else if(e == 2) {
        this.seen1 = true
      } else if(e == 3) {
        this.seen2 = true
      }
      
    },
    leave(e) {
      if (e == 1) {
        this.seen = false
      } else if(e == 2) {
        this.seen1 = false
      } else if(e == 3) {
        this.seen2 = false
      }
    },
    showfals(){
      this.logot = false
    },
    log(){
      this.logot = true
    },
    toCollect(id) {
      this.$router.push({
        path: '/page/user',
        query: {
          id: id
        }
      })
    },

    toPage(path,id) {
        this.$router.push({ path: "/page/" + path });
    },

    openWin(url,iWidth,iHeight) { 
      //获得窗口的垂直位置 
      var iTop = (window.screen.availHeight - 30 - iHeight) / 2; 
      //获得窗口的水平位置 
      var iLeft = (window.screen.availWidth - 10 - iWidth) / 2; 
      window.open(url,'_blank', 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no'); 
    },
    trigger(id) {
      this.$emit("showLogin",id);
    },
    logOut() {
      this.logot = false
      delCookie('studentId')
      delCookie('token')
      delCookie('userAcount')
      this.$router.go(0);
      this.$router.push({
        path: "/page/index"
      });
      window.location.reload();
    }
  },
  beforeMount() {
      // this.getDefaultClassify()
      
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/less/header.less");
</style>
